export default __webpack_public_path__ + "static/media/sunglass.bbe5c9e9.jpg";